
import axios from 'utils/axios';
import {dispatch, store} from 'store';

import {createSlice} from '@reduxjs/toolkit';

const initialState:any = {
  apiEndPoint: "reports/project",
  data:{},
  error:null
};

const projectsDashboard = createSlice({
  name: initialState.apiEndPoint,
  initialState,
  reducers: {
   
    // get Item details
    setData(state, action) {
      state.data = action.payload;
    },
    hasError(state, action) {
      state.error = action.payload.error;
    }
  }
});


export default projectsDashboard.reducer;

function getApiEndPoint(){
  return store.getState().projectsDashboard.apiEndPoint
}

export const { setData } = projectsDashboard.actions;


export function getProjectDshboard() {
  return async () => {
    try {
      const response = await axios.get(getApiEndPoint());
      dispatch(projectsDashboard.actions.setData(response.data));
    } catch (error) {
      dispatch(projectsDashboard.actions.hasError(error));
    }
  };
}
